// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__aur+R","opacity-transition":"success_opacity-transition__XPZKd"};